import React from 'react';
import './register.css';
import Page from '../../utils/page/page.jsx';
import ScrollView from '../../utils/scrollView/scrollView';
import { waiverURL } from '../../../apis/smartwaiver';
import { connect } from 'react-redux';
import { users } from '../../../apis/backend.js';
class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 1,
      firstName: '',
      lastName: '',
      birthday: '',
      zip: '',
      email: '',
      waiver: 1,
      responseError: false,
      response: ''
    };
  }

  changeTab(index) {
    this.setState({
      responseError: false,
      response: ''
    });
    this.setState({ tab: index });
  }

  renderRegisterButtons() {
    return {
      left: {
        title: 'Back',
        onClick: () => this.props.history.push('/activities/home')
      }
    };
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  isFormValid = () => {
    const { firstName, lastName, birthday, zip } = this.state;
    return firstName.trim() !== '' && lastName.trim() !== '' && birthday !== '' && zip !== '';
  };

  createUserWaiver = async () => {
    let haveErrors = false;
    await users
      .post(
        '/newWaiver',
        {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dateOfBirth: this.state.birthday,
          zipcode: this.state.zip,
          email: this.state.email,
          waiver: this.state.waiver
        },
        { headers: { authorization: this.props.employeeToken } }
      )
      .catch((error) => {
        haveErrors = true;
        console.error(error);
        this.setState({
          responseError: true,
          response: 'Error: ' + (error.response?.data?.err ?? error.response?.data)
        });
      });
    if (haveErrors == false) {
      this.clearState();
      this.setState({
        responseError: false,
        response: 'Success, new user and waiver were created.'
      });
    }
    return true;
  };

  createUser = async () => {
    let haveErrors = false;
    await users
      .post(
        '/',
        {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          dateOfBirth: this.state.birthday,
          zipcode: this.state.zip,
          email: this.state.email,
          tempAccess: true
        },
        { headers: { authorization: this.props.employeeToken } }
      )
      .catch((error) => {
        haveErrors = true;
        console.error(error);
        this.setState({
          responseError: true,
          response: 'Error: ' + (error.response?.data?.err ?? error.response?.data)
        });
      });
    if (haveErrors == false) {
      this.clearState();
      this.setState({
        responseError: false,
        response: 'Success, new user was created.'
      });
    }
    return true;
  };

  clearState() {
    this.setState({
      firstName: '',
      lastName: '',
      birthday: '',
      zip: '',
      email: '',
      waiver: 1
    });
  }

  showResponse() {
    console.log(this.state.response);
    return this.state.response !== '' ? true : false;
  }

  render() {
    return (
      <Page>
        <div className="registerButtonWrapper">
          <button
            className={this.state.tab == 1 ? 'active registerButton' : 'registerButton'}
            onClick={() => {
              this.changeTab(1);
            }}
          >
            Smart Waiver
          </button>
          <button
            className={this.state.tab == 2 ? 'active registerButton' : 'registerButton'}
            onClick={() => {
              this.changeTab(2);
            }}
          >
            Paper Waiver
          </button>
          <button
            className={this.state.tab == 3 ? 'active registerButton' : 'registerButton'}
            onClick={() => {
              this.changeTab(3);
            }}
          >
            Add User
          </button>
        </div>
        <ScrollView buttons={this.renderRegisterButtons()}>
          {this.state.tab == 1 ? <iframe src={waiverURL} title="smartwaiver"></iframe> : null}
          {this.state.tab == 2 ? (
            <div className="addUserWrapper">
              <div className="registerAddUser">
                <div
                  className="addUserInputLabel"
                  style={{
                    textAlign: 'center',
                    borderBottom: 'solid 3px gray',
                    marginBottom: '15px',
                    paddingBottom: '10px'
                  }}
                >
                  {this.state.tab == 2 ? <h2>Paper Waiver</h2> : <h2>Add User</h2>}
                </div>
                <div className="addUserRow">
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">First Name</div>
                    <input
                      className="addUserInput"
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={this.state.firstName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Last Name</div>
                    <input
                      className="addUserInput"
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={this.state.lastName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="addUserRow">
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Birthday</div>
                    <input
                      className="addUserInput"
                      type="date"
                      name="birthday"
                      placeholder="Birthday"
                      value={this.state.birthday}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Zip</div>
                    <input
                      className="addUserInput"
                      type="number"
                      name="zip"
                      placeholder="Zip"
                      value={this.state.zip}
                      onChange={this.handleInputChange}
                      pattern="[0-9]{5}"
                      title="Please enter a valid 5-digit zip code"
                    />
                  </div>
                </div>
                <div className="addUserRow">
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Email</div>
                    <input
                      className="addUserInput"
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Waiver Type</div>
                    <select
                      className="addUserInput"
                      value={this.state.waiver}
                      onChange={(e) => this.setState({ waiver: e.target.value })}
                    >
                      <option value="0" disabled>
                        Select Waiver Type
                      </option>
                      {this.props.waivers.map((waiver) => (
                        <option value={waiver.id} key={waiver.id}>
                          {waiver.name}
                        </option>
                      ))}
                      {/* <option value="1">Liability Waiver</option> */}
                    </select>
                  </div>
                </div>
                {this.state.response != '' ? (
                  <div
                    className={
                      this.state.responseError ? 'hasError responseWrapper' : 'responseWrapper'
                    }
                  >
                    <p>{this.state.response}</p>
                  </div>
                ) : null}
                <div className="addUserButtonContain" style={{ justifyContent: 'flex-end' }}>
                  <button
                    className="addUserButton"
                    onClick={() => this.createUserWaiver()}
                    disabled={!this.isFormValid()}
                  >
                    Add User
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {this.state.tab == 3 ? (
            <div className="addUserWrapper">
              <div className="registerAddUser">
                <div
                  className="addUserInputLabel"
                  style={{
                    textAlign: 'center',
                    borderBottom: 'solid 3px gray',
                    marginBottom: '15px',
                    paddingBottom: '10px'
                  }}
                >
                  {this.state.tab == 2 ? <h2>Paper Waiver</h2> : <h2>Add User</h2>}
                </div>

                <div className="addUserRow">
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">First Name</div>
                    <input
                      className="addUserInput"
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={this.state.firstName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Last Name</div>
                    <input
                      className="addUserInput"
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={this.state.lastName}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="addUserRow">
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Birthday</div>
                    <input
                      className="addUserInput"
                      type="date"
                      name="birthday"
                      placeholder="Birthday"
                      value={this.state.birthday}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Zip</div>
                    <input
                      className="addUserInput"
                      type="number"
                      name="zip"
                      placeholder="Zip"
                      value={this.state.zip}
                      onChange={this.handleInputChange}
                      pattern="[0-9]{5}"
                      title="Please enter a valid 5-digit zip code"
                    />
                  </div>
                </div>
                <div className="addUserRow">
                  <div className="addUserColumn">
                    <div className="addUserInputLabel">Email</div>
                    <input
                      className="addUserInput"
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>

                {this.state.response != '' ? (
                  <div
                    className={
                      this.state.responseError ? 'hasError responseWrapper' : 'responseWrapper'
                    }
                  >
                    <p>{this.state.response}</p>
                  </div>
                ) : null}
                <div className="addUserButtonContain" style={{ justifyContent: 'flex-end' }}>
                  <button
                    className="addUserButton"
                    onClick={() => this.createUser()}
                    disabled={!this.isFormValid()}
                  >
                    Add User
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </ScrollView>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  waivers: state.activities.activities.waivers,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps)(Register);
